<template>
  <div id="app">
    <!--主题色-->
    <!--<link rel="stylesheet" type="text/css" :href="root+'/Public/style.css'"/>-->
    <keep-alive>
      <router-view
        :config-data="config"
        :user-config="userConfig"
        v-if="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view
      :config-data="config"
      :user-config="userConfig"
      v-if="!$route.meta.keepAlive"
    ></router-view>
    <to-top></to-top>

  </div>
</template>

<script>
import Loading from "@/components/loading";
import ToTop from "@/components/totop";
import store from "./vuex/store";
import Vue from "vue";
export default {
  name: "App",
  components: {
    Loading,
    ToTop
  },
  store,
  data() {
    return {
      config: "",
      userConfig: ""
    };
  },
  methods: {
    isWap() {
      const malltype = window.location.host.split('.')[0];
      return this.$api.post('redirect/index', {prefix: malltype}, res => {
        if (res.data.data.indexOf(window.location.host) == -1) {
          return
          window.location.href = res.data.data
        }
      })
    },
    getconfig: function() {
      var malltype = window.location.host.split(".")[0];
      // var url = "/sys/info/domain/xl"; //本地测试地址
      var url = "/sys/info"; //正式地址
      this.$api.get(url, { terminal: "wap", domain: malltype }, res => {
        if (res.data.code == "100") {
          var mallid = res.data.data.id_example;
          var id = res.data.data.id_example;
          localStorage.setItem("mallid", id); //商城ID
          var visitor = res.data.data.visitor_status;
          var closed = res.data.data.switch_status;
          localStorage.setItem("closed", closed);
          this.$store.commit("setClosed", closed);
          this.$store.commit("setMallStock", res.data.data.stock_status);
          localStorage.setItem("login_code", res.data.data.wx_app_id)
          if (closed == 0 || closed == -1) {
            //商城关闭
            this.$router.push({ name: "Closed" });
            document.body.removeChild(document.getElementById("Loading"));
            return;
          }
          document.title = res.data.data.name; //商城名称
          this.loadStyle(mallid); //加载主题色
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link"); //商城icon
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          if (
            res.data.data.logo_icon == "" ||
            res.data.data.logo_icon == null
          ) {
            link.href = "/static/favicon.ico"; //默认图标
          } else {
            link.href = res.data.data.logo_icon; //商城icon
          }
          document.getElementsByTagName("head")[0].appendChild(link); //设置ico
          localStorage.setItem("visitor", visitor);
          this.$api.get("sys/maintain", { id_example: mallid }, res => {
            if (res.data.code == "100") {
              if (res.data.data.status == 1) {
                //商城维护
                this.$router.push({ name: "Maintain" });
                document.body.removeChild(document.getElementById("Loading"));
              } else {
                //                this.$store.commit('userInfo')
                //                 this.getUser()
                if (visitor == 0) {
                  //游客模式 1为开启 0为关闭
                  var isUser = localStorage.getItem("BLHuser");
                  if (isUser != null && isUser != undefined && isUser != "") {
                  } else {
                    this.$router.push({ path: "/login" });
                  }
                  document.body.removeChild(document.getElementById("Loading"));
                } else {
                  document.body.removeChild(document.getElementById("Loading"));
                }
              }
            }
          });
        }
      });
    },
    getAddress() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.get(
        "user/address/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            res.data.data.forEach(item => {
              if (item.default == 1) {
                var area = "";
                area += item.province_str;
                area += "-" + item.city_str;
                area += "-" + item.county_str;
                if (item.town_str != "") {
                  area += "-" + item.town_str;
                }
                var json = {
                  area: area,
                  province_id: item.province,
                  city_id: item.city,
                  country_id: item.county,
                  town_id: item.town ? item.town : 0
                };
                this.$store.commit("setAddress", json);
              }
            });
          }
        }
      );
    },
    loadStyle: function(url) {
      //生成主题色css文件
      var link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      // link.href = 'http://fenimge.li91.net/Uploads/Static/css/style'+url+'.css';//测试服
      link.href = "https://shopapi.fensaas.com/static/css/style" + url + ".css"; //正式服
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(link);
    },
    GetQueryString: function(name) {
      //获取url
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则
      if (r != null) return unescape(r[2]);
      return null;
    }
  },
  created() {},
  async mounted() {
    if(location.host === 'zgjh.mall.fensaas.com') {
      location.replace('https://u4mdfq.m.newfen.top')
      return
    }
    await this.isWap()
    //判断是否是兑换平台
    var arr = [
      "Eordercomit",
      "Eordersucceed",
      "Eorderlist",
      "Elogistics",
      "Eorder",
      "Eguide",
      "Elogin",
      "Eindex",
      "Edetail",
      "Eaddsite",
      "Eordersucceed",
      "Over"
    ];
    var name = this.$route.name;
    if (arr.indexOf(name) >= 0) {
      //兑换平台调用vux里兑换平台的接口,
      document.body.removeChild(document.getElementById("Loading"));
      var url = this.GetQueryString("gid");
      if (url == null) {
        this.$router.push({ name: "Over" });
      }
      this.$store.commit("exchange");
      //获取兑换平台组主题色
      var link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      // link.href = 'http://fenimge.li91.net/Uploads/Static/css/styleLk'+url+'.css';//测试服
      link.href =
        "https://shopapi.fensaas.com/static/css/styleLk" + url + ".css"; //正式服
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(link);
    } else {
      //商城必要接口调用
      this.$store.commit("webInfo");
      this.getconfig();
      this.getAddress();
    }
  }
};
</script>
<style lang="less">
#app {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
}

.van-dialog {
  width: 90vw !important;
  .van-dialog__header {
    height: 1.06rem !important;
    background: #f5f5f5;
    border-radius: 0.24rem 0.24rem 0rem 0rem;
    padding: 0;
    line-height: 1.06rem;
    text-align: center;
  }

  .van-dialog__content {
    padding-top: 0.4rem;

    .van-dialog__message {
      font-size: 0.32rem;
      font-weight: 500;
      color: #262626;
      line-height: 0.54rem;
    }
  }

  .van-dialog__footer {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.4rem 0.4rem 0.4rem;
    border: none;
    display: flex;
    justify-content: center;

    &::before {
      border: none;
    }

    &::after {
      border: none;
    }

    .van-button {
      flex: none;
      width: 2.68rem;
      height: 0.8rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      color: #fff;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin: 0 0.22rem;

      &::after {
        border: none;
      }
    }

    .van-dialog__cancel {
      background: #fdf5f5;
      border: 0.02rem solid #e23331;
      color: #e23331 !important;
      .van-button__content {
        color: #e23331 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue